/* global URL_API_PLICK */
/* global API_KEY_PLICK */
import axios from 'axios';

const instanceAPI = axios.create({
  baseURL: URL_API_PLICK,
  timeout: 30 * 1000,
  headers: {},
});

instanceAPI.interceptors.request.use(
  (config) => {
    config.headers.Authorization = API_KEY_PLICK;
    config.headers.PanelSession = localStorage.getItem('token') || '';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default instanceAPI;
